<ul class="flex flex-col divide-y divide-orangeLightX overflow-y-auto h-full bg-warmGray rounded-xl p-2"
[ngClass]="backendSrv.showFullMenu ? 'w-64' : 'w-24'"
  *ngIf="!updating">
  <div class="flex w-full" [ngClass]="backendSrv.showFullMenu ? 'justify-between' : 'justify-center'">
    <h3 *ngIf="backendSrv.showFullMenu" class="font-bold text-gray-600">Website-Elemente</h3>
    <button (click)="backendSrv.showFullMenu = !backendSrv.showFullMenu">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="size-6 text-gray-700 transition-all duration-150" [ngClass]="backendSrv.showFullMenu ? 'rotate-180' : ''">
        <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
      </svg>
    </button>
  </div>
  <div class="flex flex-col overflow-y-auto h-full mt-1">
    <li class="flex cursor-pointer rounded-md m-0.5"
      [ngClass]="selectedIndex === i ? 'bg-orangeLight text-white': 'text-gray-700 hover:bg-orangeLightX hover:text-orange'"
      *ngFor="let backend of tables; let i = index" (click)="selectedIndex = i" [routerLink]="[
    '/backend',
    { outlets: { backendOutlet: [this.backend.dbName] } },
  ]">
      <div class="flex mx-4 my-2 items-center space-x-2">
        <mat-icon *ngIf="backend && backend.icon">
          {{backend?.icon}}
        </mat-icon>
        <span class="text-sm font-semibold" *ngIf="backendSrv.showFullMenu">{{backend.prettyName}}</span>
      </div>
    </li>
  </div>
</ul>
<ts-loader class="center" *ngIf="updating"></ts-loader>